export default __webpack_public_path__ + "static/media/avatar_unicorn1.f4516c99.mp3";